module.exports = __webpack_public_path__ + "images/logo_loudup_mini.png?a6b8d";